module.exports = __webpack_public_path__ + "static/media/6_secretary_Joey Chan.398094dd.jpeg";